import { createSlice } from '@reduxjs/toolkit'

interface TextbookState {
  currentTextbook: any | null
  chapters: any[]
}

const initialState: TextbookState = {
  currentTextbook: null,
  chapters: [],
}

const textbookSlice = createSlice({
  name: 'textbook',
  initialState,
  reducers: {
    setCurrentTextbook: (state, action) => {
      state.currentTextbook = action.payload
    },
    setChapters: (state, action) => {
      state.chapters = action.payload
    },
  },
})

export const { setCurrentTextbook, setChapters } = textbookSlice.actions
export default textbookSlice.reducer

